import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { getTierThresholdDisplayItems } from '../../../constants/pricingTierConfig';
import ThresholdChipsSummary from './ThresholdChipsSummary';

const TierDiscountSummary = ({ tier, currency, compact, tableView = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const useCompact = tableView ? false : (compact ?? isMobile);
    const items = getTierThresholdDisplayItems(tier, currency);

    return (
        <ThresholdChipsSummary items={items} compact={useCompact} tableView={tableView} />
    );
};

export default TierDiscountSummary;
